import { z } from "zod";

export const isZodSuccess = <Input, Output>(
  result: z.SafeParseReturnType<Input, Output>,
): result is z.SafeParseSuccess<Output> => {
  return result.success;
};

export const isZodError = <Input, Output>(
  result: z.SafeParseReturnType<Input, Output>,
): result is z.SafeParseError<Input> => {
  return !result.success;
};

export const zodErrorToMap = <Input>(result: z.SafeParseError<Input>) => result.error.flatten().fieldErrors;

// -------------------

export const zRequiredString = (message: string = "required") => z.string({ required_error: message }).min(1, message);
export const zRequiredNumber = (message: string = "required") => z.number({ required_error: message });
export const zRequiredBoolean = (message: string = "required") => z.boolean({ required_error: message });

// --------------------

export * from "./zodBondBenchmark";
export * from "./zodDateTime";
export * from "./zodDecimal";
export * from "./zodMoney";
export * from "./zodOrderStatuses";
export * from "./zodRatings";
export * from "./zodBond";
export * from "./zodCurrency";
